import { Facepile, IFacepileProps } from '@fluentui/react/lib/Facepile';

export interface IPFacepileProps extends IFacepileProps {}
export type { IFacepilePersona as IPFacepilePersona } from '@fluentui/react/lib/Facepile';
export { OverflowButtonType as IPOverflowButtonType } from '@fluentui/react/lib/Facepile';

export const IPFacepile = (props: IPFacepileProps) => {
  return <Facepile {...props} />;
};
